/**
 * „Antworten im Hintergrund vorlesen (Test)“ — der Schalter für den nativen Vorleser der iPhone-App. (13.10.2026)
 *
 * Der native Weg ist seit dem 24.09. abgeschaltet (frontend/lib/vorlesen-nativ.ts). Damit ein neuer iPhone-Build getestet
 * werden kann, ohne dass andere Konten oder Geräte etwas merken, hängt er an diesem Kontowert: Vorgabe AUS, nur ein
 * ausdrückliches `true` zählt. Er wirkt zusätzlich nur bei verborgener Seite (das prüft das Frontend).
 */

/** Der Schlüssel in den Einstellungen des Kontos. */
export const VORLESER_NATIV_FELD = "vorleserNativ";

/** Ist der Schalter an? Nur ein ausdrückliches `true` zählt. Rein. */
export function vorleserNativAn(wert: unknown): boolean {
  return wert === true;
}
